import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ImageOff } from "lucide-react";

// Loads a stored object-storage image using the auth token (img tags can't send headers).
export function AuthImage({ path, alt = "", className = "" }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objectUrl;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        if (revoked) return;
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
      })
      .catch(() => setError(true));
    return () => { revoked = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);

  if (error) return <div className={`grid place-items-center bg-[#F2EFE9] text-[#6B7280] ${className}`}><ImageOff size={18} /></div>;
  if (!url) return <div className={`animate-pulse bg-[#EAE6DF] ${className}`} />;
  return <img src={url} alt={alt} className={className} />;
}
